import req from '@/api/config/config'
export default {
  getPicCode(parmas) {
    // 获取密码登录验证码图片
    return req.service({
      url: '/',
      method: 'post',
      parmas:parmas
    })
  },
  verifyCode() {
    return req.service({
      url: `${req.user}/v1/manage/loginUser/verifyCode`,
      method: 'get'
    })
  },
  getcode(params) {
    return req.service({
      url: `${req.user}/v1/app/loginUser/getVerificationCode`,
      method: 'get',
      params
    })
  },
  // 企业规模选择器
  getEnterpriseSize(params) {
    return req.service({
      url: `${req.systemIp}/pc/ext/statistics/project/supplierScale/dropDown`,
      method: "get",
      headers: {
        "BIDDING-SOURCE": "pc/ext",
      },
      params,
    })
  },
  // 新增供应商
  register(data) {
    return req.service({
      url: `${req.systemIp}/website/supplier/addSupplier`,
      method: 'post',
      data
    })
  },
  ///////////////////////////////

  //获取手机验证码
  getVCode(data) {
    return req.service({
      url: `${req.systemIp}/pc/ext/supplier/user/send_sms?phone=${data}`,
      // url: `${req.systemIp}/wx/supplier/user/send_sms?phone=${data.phone}`,
      method: 'post',
      headers:{
        // 'BIDDING-SOURCE':'WX',
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data
    })
  },


  //注册
  register(data) {
    return req.service({
      url: `${req.systemIp}/pc/ext/supplier/user/register`,
      method: 'post',
      headers:{
        'BIDDING-SOURCE':'pc/ext'
      },
      data
    })
  },

}